import React, { Component } from "react";
import { Link } from "react-router-dom";

class Header extends Component {
  render() {
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-md trans-all"
        id="myNav"
      >
        <div className="container d-flex justify-content-between">
          <Link className="navbar-brand" to={this.props.destination}>
            <img
              src="/img/creatifa-logo-with-text.png"
              height="30"
              className="d-inline-block align-top ms-md-0 ms-2"
              alt=""
            />
          </Link>

          {this.props.menu}
        </div>
      </nav>
    );
  }
}

export default Header;
